module.exports = __webpack_public_path__ + "svg/footer-wave.svg";